export const UNITED_STATES = 'us';
export const MEXICO = 'Mexico';
export const MEXICO_COUNTRY_CODE = 'MX';
